import { totalMissingDetails } from '@shared/consumerPlan';
import { Checklist } from '../components/checklist';
import { StepFrame } from '../components/step-frame';
import { useApplication } from '../hooks/use-application';
import type { ConsumerStepProps } from './step-props';

export function SubmittedStep({ clientId }: ConsumerStepProps) {
  const { answers, sections } = useApplication(clientId);
  const missing = totalMissingDetails(answers, sections);

  return (
    <StepFrame
      step="submitted"
      title="Your application is with our team."
      subtitle="Coverage isn’t active yet. Here’s what happens next."
      help={
        <>
          <p>We’ll follow up if our team or the insurance company needs clarification. Checks reduce avoidable errors; they can’t guarantee a delay-free decision.</p>
          <p>If you want to change your coverage while the application is in review, email our team and they’ll coordinate it.</p>
        </>
      }
    >
      <Checklist
        items={[
          {
            marker: 'done',
            title: 'Application sent to our team',
            description: missing ? `${missing} details for us to follow up on` : 'All sections complete',
          },
          { marker: 1, title: 'We check for errors and missing details', description: 'To help avoid delays before carrier submission' },
          { marker: 2, title: 'We coordinate underwriting with the carrier', description: 'Including the preliminary eligibility inquiry' },
          { marker: 3, title: 'We handle formal carrier submission', description: 'The carrier decides eligibility and final terms' },
        ]}
      />
    </StepFrame>
  );
}
